import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";

class questionaryDataccess {
  getSupplierQuestionary(supplierId: number) {
    return commonDataAccess.getData("Questionary/get/supplier-questionary", {
      supplierId: supplierId,
    });
  }
  // deleteQuestionaryInfo(id: any) {
  //   return commonDataAccess.deleteData("Questionary/delete", {
  //     id: id,
  //   });

  deleteQuestionaryInfo = (ids: number | number[]) => {
    if (Array.isArray(ids)) {
      return commonDataAccess.postData("Questionary/deleteAll", ids);
    } else {
      return commonDataAccess.deleteData(`Questionary/delete/${ids}`);
    }
  };

  getList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData("Questionary/getall", parameters);
  };
  getGeneralInfo = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "Questionary/get/generalinfo/" + params,
      {}
    );
    return result;
  };
  saveGeneralInfo = (data: any, id: number) => {
    return commonDataAccess.postData("Questionary/save/generalinfo", data, {
      id: id,
    });
  };
  getDropdownForQuestionnaire = (
    supplierId: number,
    searchValue: any = "",
    selectedSupplierIds: any = ""
  ) => {
    return commonDataAccess.getData(
      "Questionary/get/dropdownListForQuestionnaire",
      {
        supplierId: supplierId,
        searchValue: searchValue,
        selectedIdsString: selectedSupplierIds,
      }
    );
  };

  getSupplierCompletedQuestionary(supplierId: number) {
    return commonDataAccess.getData(
      "Questionary/getSupplierCompletedQuestionary",
      {
        supplierId: supplierId,
      }
    );
  }

  saveSupplierCompletedQuestionary = async (data: any) => {
    console.log("save data", data);
    var result = await commonDataAccess.postData(
      "Questionary/save/supplierCompletedQuestionary",
      data
    );
    console.log("save result", result);
    return result;
  };

  deleteCompletedQuestionnaire = (id: number) => {
    return commonDataAccess.deleteData(
      "Questionary/deleteCompletedQuestionary",
      {
        id: id,
      }
    );
  };

  saveSupplierLinkedQuestionnaire = (data: any) => {
    return commonDataAccess.postData(
      "Questionary/save/supplierLinkedQuestionnaire",
      data
    );
  };

  requestQuestionnaireToBeCompleted = (data: any) => {
    return commonDataAccess.postData(
      "Questionary/email-questionnaire-to-supplier",
      data
    );
  };

  getOverdueQuestionnaireListAsync = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData(
      "Questionary/overdue-questionnaires",
      parameters
    );
  };
  notifyRecipientToComplete = (data: any) => {
    return commonDataAccess.postData(
      "Questionary/notify-recipient-to-complete",
      data
    );
  };
  getQuestionnaireDropdown = () => {
    return commonDataAccess.getData("Questionary/get/questionnairesDropdown");
  };

}

export default new questionaryDataccess();
